export { getCookie } from '@inwink/utils/cookies';

function getCookieExpireDate() {
    const cookieTimeout = 33696000000;
    const date = new Date();
    date.setTime(date.getTime() + cookieTimeout);
    const expires = "; expires=" + date.toUTCString();
    return expires;
}


export function setCookie(cname: string, cvalue: string) {
    document.cookie = `${cname}=${cvalue}; ${getCookieExpireDate()} ; path=/`;
}